import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import withAuthentication from '@on3/ui-lib/src/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/src/hocs/withValidUrl';
import { AboutPage } from 'components/About/AboutPage';
import { PageWrapper } from 'components/Layouts/PageWrapper';
import type { GetServerSideProps } from 'next';

const About = (props: IGenericPageProps) => {
  return (
    <PageWrapper {...props} title="About | On3.com">
      <AboutPage />
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      pageType: 'page',
      siteData: siteData || [],
      userData: userData || {},
    },
  };
};

export default withValidUrl(About);
